export enum QuizTabStatus {
	PENDING = "Pending",
	IN_PROGRESS = "In Progress",
	ALL = "All",
	COMPLETE = 'Completed'
}